export const DEFAULT_LANGUAGE = 'en-US';
export const TEACHER = 'TEACHER';
export const STUDENT = 'STUDENT';
export const DISTRICT_OWNER = 'DISTRICT_OWNER';
export const SCHOOL_ADMIN = 'SCHOOL_ADMIN';
export const MS_URL = 'https://ms.twigscience.com';
export const K6_URL = 'https://app.twigscience.com';
export const MS_PRODUCT_CODE = 'TSMS';
export const K6_PRODUCT_CODE = 'TSK6';
export const FLAG_RTK_ROSTERING_DEPRECATIONS = 'rtk-rostering-deprecations';
